import { epic$, store } from '@redux/store';
import articleSearchParametersSlice from './redux/slices'
import { fetchArticlesEpic, fetchArticlesCountsEpic } from './redux/epics';
import onArticleCountResultsLoaded$ from './listeners/articleCountResults';
import { onArticleSearchResultsLoaded$,
   onSuccesedArticleSearchResults$, onloadingArticleSearchResults$ } from './listeners/articleSearchResults';
import {
  selectArticlesQueryStringParameters,
  selectSearchTerm,
  selectPage,
  selectPageSize,
  selectCategoryNames,
} from './redux/selectors';

epic$.next(fetchArticlesEpic);
epic$.next(fetchArticlesCountsEpic);

const { actions, reducer } = articleSearchParametersSlice;
store.injectReducer('articleSearchParameters', reducer);
export {
  actions as articleSearchResultsActions,
  reducer as articleSearchResultsReducers,
  onArticleCountResultsLoaded$,
  onArticleSearchResultsLoaded$,
  onSuccesedArticleSearchResults$,
  onloadingArticleSearchResults$,
  selectArticlesQueryStringParameters,
  selectSearchTerm,
  selectPage,
  selectPageSize,
  selectCategoryNames,
}
